import { AuthApi } from "@/api/AuthApi";
import { UserApi } from "@/api/UserApi"
import { TokenLoginReq } from "@/types/User";

export function useAuth() {
    const userApi = new UserApi()
    const authApi = new AuthApi()
    const verifyPassword = async (password: string) => {
        try {
            return await userApi.verifyPassword(password)
        } catch (e) {
            return false;
        }
    }

    const tokenLogin = async (userId: number, accessToken: string) => {
        const req: TokenLoginReq = {
          userId,
          accessToken
        }
        return await authApi.tokenLogin(req)
      }

    return {
        verifyPassword,
        tokenLogin
    }
}